// Path: /Users/P341939/workspace/pcds-roadmap/src/utils/versionUtils.js
/**
 * Utility function to validate version format.
 * @param {string} version - The version string to validate.
 * @returns {boolean} - Whether the version is valid.
 */
export const isValidVersion = (version) => {
  const match = version.match(/^PI-(\d{2})\.(\d+)$/);
  if (!match) return false;
  // eslint-disable-next-line no-unused-vars
  const [_, year, quarter] = match.map(Number);
  return year > 25 || (year === 25 && quarter >= 4);
};
